// Steam Barons — Tier-A bundle (server/test-safe). NO image imports. Generated by create-mod.
import { RULES } from '../dominion/rules';
import { BOARD_SPACES, COLOR_GROUPS } from '../dominion/board';
import { CHANCE_CARDS, COMMUNITY_CARDS } from '../dominion/cards';
import { CHARACTERS_DATA, getCharacterById, getStartingMoney } from './characters-data';
import { CHARACTER_LORE, getLoreById } from './lore';
import data from './steam-barons.data.json';

export const steamBaronsData = {
  id: 'steam-barons',
  name: "Steam Barons",
  tagline: "Industrialists race to corner a compact circuit.",
  version: "1.0.0",

  rules: RULES,
  characters: CHARACTERS_DATA,
  board: { spaces: BOARD_SPACES, colorGroups: COLOR_GROUPS },
  cards: { chance: CHANCE_CARDS, community: COMMUNITY_CARDS },
  lore: CHARACTER_LORE,

  getCharacterById,
  getStartingMoney,
  getLoreById,

  maps: [data.map],
  worlds: [],
};

export default steamBaronsData;
